
    import './styles.scoped.css';
    export default {
  "root": "awsui_root_14iqq_tibi1_97",
  "variant-default": "awsui_variant-default_14iqq_tibi1_109",
  "variant-stacked": "awsui_variant-stacked_14iqq_tibi1_109",
  "header": "awsui_header_14iqq_tibi1_132",
  "header-sticky-disabled": "awsui_header-sticky-disabled_14iqq_tibi1_136",
  "header-sticky-enabled": "awsui_header-sticky-enabled_14iqq_tibi1_140",
  "header-stuck": "awsui_header-stuck_14iqq_tibi1_146",
  "with-divider": "awsui_with-divider_14iqq_tibi1_150",
  "header-dynamic-height": "awsui_header-dynamic-height_14iqq_tibi1_154",
  "with-paddings": "awsui_with-paddings_14iqq_tibi1_160",
  "content": "awsui_content_14iqq_tibi1_164",
  "footer": "awsui_footer_14iqq_tibi1_171"
};
  